import { render, staticRenderFns } from "./SimplePageHeader.vue?vue&type=template&id=b5c8c362&scoped=true"
import script from "./SimplePageHeader.vue?vue&type=script&lang=js"
export * from "./SimplePageHeader.vue?vue&type=script&lang=js"
import style0 from "./SimplePageHeader.vue?vue&type=style&index=0&id=b5c8c362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c8c362",
  null
  
)

export default component.exports